import { render } from "./FooterPartial.vue?vue&type=template&id=61216b57"
import script from "./FooterPartial.vue?vue&type=script&lang=js"
export * from "./FooterPartial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__